<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-form-item v-bind="errorsBind('non_field_errors')" />
    <a-form-item label="Zakres dat" v-bind="errorsBind('name')" required>
      <a-range-picker :ranges="ranges" @change="onChange" />
    </a-form-item>
  </a-form>
</template>

<script>
import FieldHelper from '@/components/common/forms/FieldsHelper'
import moment from 'moment'

export default {
  extends: FieldHelper,
  computed: {
    ranges() {
      return {
        'Ten miesiąc': [moment().startOf('month'), moment().endOf('month')],
        'Poprzedni miesiąc': [
          moment()
            .subtract(1, 'months')
            .startOf('month'),
          moment()
            .subtract(1, 'months')
            .endOf('month')
        ],
        'Ten tydzień': [moment().startOf('week'), moment().endOf('week')],
        'Poprzedni tydzień': [
          moment()
            .subtract(1, 'weeks')
            .startOf('week'),
          moment()
            .subtract(1, 'weeks')
            .endOf('week')
        ]
      }
    }
  },
  methods: {
    onChange(value) {
      this.form = {
        ...this.form,
        timespan_after: this.getDateOnly(value[0]),
        timespan_before: this.getDateOnly(value[1])
      }
    }
  }
}
</script>
